var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.5 19.121"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon Arrow Go",
    fill: "none",
    stroke: "#333230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10297",
    d: "M9.542 1.06l8.208 8.5-8.208 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 2",
    d: "M.75 9.56h17"
  }))));
}
export default SvgArrowGo;